import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseKnowledgeCatalogService {
  baseKnowledgeCatalog = 'api/BaseKnowledgeCatalog';
  constructor(private _baseKnowledgeCatalogHttp: RestApi) { }

  getBaseKnowledgeCatalog(): Observable<any> {
    return this._baseKnowledgeCatalogHttp.get(`${this.baseKnowledgeCatalog}/GetBaseKnowledgeCatalog`);
  }
}
